// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/forKantonsrat/SearchInputGroup.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/forKantonsrat/SearchInputGroup.tsx");
  import.meta.hot.lastModified = "1726148920286.584";
}
// REMIX HMR END

import { useNavigate, useParams } from "@remix-run/react";
import { useRef, useState } from "react";
import { BEHOERDEN_GREMIEN_LABEL_SHORT, GESCHAEFTE_ARTEN } from "~/resources/static_data";
import { createLangPathByParam } from "~/utils/lang";
import { useLang } from "~/utils/provider/lang-provider";
export default function SearchInputGroup({
  useCase
}) {
  _s();
  const [inpErr, setInpErr] = useState(null);
  const navigate = useNavigate();
  const {
    lang
  } = useParams();
  const p1Ref = useRef(null);
  const p2Ref = useRef(null);
  const p3Ref = useRef(null);
  const p4minRef = useRef(null);
  const p4maxRef = useRef(null);
  const p12Ref = useRef(null);
  const titelRef = useRef(null);
  const l_kantonsrat = useLang('kantonsrat');
  const allRefs = [p1Ref, p2Ref, p3Ref, p4minRef, p4maxRef, p12Ref, titelRef];
  const onTriggerSearch = e => {
    e.preventDefault();
    e.stopPropagation();
    if (p4minRef?.current?.value && p4maxRef?.current?.value && parseInt(p4minRef?.current?.value) > parseInt(p4maxRef?.current?.value)) {
      setInpErr('min larger than max');
      return;
    }
    const sps = new URLSearchParams();

    // setSearchParams((prev) => {
    for (let i = 0; i < allRefs.length; i += 1) {
      const oneRef = allRefs[i];
      if (oneRef.current && oneRef.current.value) {
        const dl = oneRef.current.dataset;
        const idx = dl.idx;
        const qua = dl.qua;
        const val = oneRef.current.value;
        if (useCase === 'personen') {
          sps.set(`p${idx}`, `${val},${qua}`);
        } else if (useCase === 'mitglieder') {
          if (idx === 'wahlkreis') {
            sps.set(`${idx}`, `${val}`);
          } else {
            sps.set(`p${idx}`, `${val}`);
          }
        } else if (useCase === 'sitzungen') {
          sps.set('gremium', val);
        } else if (useCase === 'geschaefte') {
          sps.set(`${idx}`, `${val}`);
        }
      }
    }
    navigate({
      pathname: createLangPathByParam(lang, `/kantonsrat/${useCase}`),
      search: sps.toString()
    });
  };
  const onFilterReset = () => {
    for (let i = 0; i < allRefs.length; i += 1) {
      const oneRef = allRefs[i];
      if (oneRef.current) oneRef.current.value = "";
    }
    navigate(createLangPathByParam(lang, `/kantonsrat/${useCase}`));
  };
  return <form className="srch_bx">
            {useCase === "mitglieder" || useCase === 'personen' ? <>
                    <div style={{
        fontWeight: 500,
        fontSize: '1.25rem',
        textAlign: 'center',
        backgroundColor: 'var(--gray3)'
      }}>
                        {l_kantonsrat('st_search_persons')}
                    </div>

                    <label htmlFor="firstName" className="search_inp_group">
                        <span>{l_kantonsrat('l_first_name')}</span>
                        <input ref={p1Ref} type="text" id="firstName" data-idx="2" data-qua="inc" />
                    </label>
                    <label htmlFor="lastName" className="search_inp_group">
                        <span>{l_kantonsrat('l_last_name')}</span>
                        <input ref={p2Ref} type="text" id="lastName" data-idx="1" data-qua="inc" />
                    </label>

                    <label htmlFor="geschlecht" className="search_inp_group">
                        <span>{l_kantonsrat('l_sex')}</span>
                        <select id="geschlecht" ref={p3Ref} data-idx="3" data-qua="equ" className="btn_2">
                            <option value="">
                                {l_kantonsrat('l_all')}
                            </option>
                            <option value="m">
                                {l_kantonsrat('l_male')}
                            </option>
                            <option value="w">
                                {l_kantonsrat('l_female')}
                            </option>
                        </select>
                    </label>
                </> : null}

            {useCase === 'mitglieder' ? <>
                    <label htmlFor="wahlkreis" className="search_inp_group">
                        <span>{l_kantonsrat('l_wahlkreis')}</span>

                        <select id="wahlkreis" ref={p3Ref} data-idx="wahlkreis" data-qua="equ" className="btn_2">
                            <option value="">{l_kantonsrat('l_all')}</option>
                            {["I Zürich 1+2", "II Zürich 3+9", "III Zürich 4+5	", "IV Zürich 6+10	", "IX Horgen", "V Zürich 7+8", "VI Zürich 11+12", "VII Dietikon", "VIII Affoltern	", "X Meilen", "XI Hinwil", "XII Uster", "XIII Pfäffikon", "XIV Winterthur Stadt", "XV Winterthur Land", "XVI Andelfingen", "XVII Bülach", "XVIII Dielsdorf"].map((it, ind) => <option key={ind} value={it}>{it}</option>)}
                        </select>
                    </label>
                </> : null}

            {useCase === 'personen' ? <>
                    <label htmlFor="gebvor" className="search_inp_group">
                        <span>{l_kantonsrat('l_born_before')}</span>
                        <input min={1600} max={2010} ref={p4maxRef} type="number" id="gebvor" data-idx="6" data-qua="max" />
                    </label>

                    <label htmlFor="gebnach" className="search_inp_group">
                        <span>{l_kantonsrat('l_born_after')}</span>
                        <input min={1600} max={2010} ref={p4minRef} type="number" id="gebnach" data-idx="6" data-qua="min" />
                    </label>

                    <label htmlFor="beruf" className="search_inp_group">
                        <span>{l_kantonsrat('l_occupation')}</span>
                        <input ref={p12Ref} type="text" id="beruf" data-idx="12" data-qua="inc" />
                    </label>
                </> : null}


            {useCase === 'sitzungen' ? <>
                    <label htmlFor="sitzungen" className="search_inp_group">
                        <span>{l_kantonsrat('l_gremium')}</span>
                        <select id="sitzungen" ref={p3Ref} data-idx="sitzungen" data-qua="equ" className="btn_2">
                            <option value="">{l_kantonsrat('l_all')}</option>
                            {BEHOERDEN_GREMIEN_LABEL_SHORT.map((it, ind) => <option key={ind} value={it[1]}>{it[0]}</option>)}
                        </select>
                    </label>
                </> : null}


            {useCase === 'geschaefte' ? <>
                    <label htmlFor="titel" className="search_inp_group">
                        <span>{l_kantonsrat('l_title')}</span>
                        <input ref={titelRef} type="search" id="titel" data-idx="titel" data-qua="max" />
                    </label>
                    <label htmlFor="geschaefte" className="search_inp_group">
                        <span>{l_kantonsrat('l_geschaefts_art')}</span>
                        <select id="geschaefte" ref={p3Ref} data-idx="art" data-qua="equ" className="btn_2">
                            <option value="">{l_kantonsrat('l_all')}</option>
                            {GESCHAEFTE_ARTEN.map((it, ind) => <option key={ind} value={it}>{it}</option>)}
                        </select>
                    </label>
                </> : null}

            {inpErr ?? ''}
            <button type="submit" style={{
      padding: '0.5rem',
      justifyContent: 'center'
    }} className="btn_1" onClick={e => onTriggerSearch(e)}>
                {l_kantonsrat('l_search')}
            </button>

            <button type="reset" style={{
      padding: '0.5rem',
      justifyContent: 'center'
    }} className="btn_3" onClick={() => onFilterReset()}>
                {l_kantonsrat('l_reset')}
            </button>

        </form>;
}
_s(SearchInputGroup, "DJvAvOL+vxRh6glFLcngs8jDgv4=", false, function () {
  return [useNavigate, useParams, useLang];
});
_c = SearchInputGroup;
var _c;
$RefreshReg$(_c, "SearchInputGroup");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;